import {AxiosResponse} from "axios"
import {FetchResult} from "@apollo/client"
import {getGraphError} from "../errorHandler/getGraphError"
import {ErrorRequestLike} from "."
import stopAllAuthStreams from "@irati/utils/history/utils/auth/stopAllStreams"

export default (err?: ErrorRequestLike) => {
  return new Promise((resolve, reject) => {
    stopAllAuthStreams()
    /**
      No resolve/reject as we want this promise to hang.
      No chained code should execeute (neither success or error handles)
      @author: Richard Scoones
    */

    /**
     * However.... apollo caches requests too, if we just hang it will not make
     * another request for ever.... this is bad.
     * @author: Richard Scoones
     */
    if (isApolloQuery(err)) {
      reject(getGraphError(err.data.errors))
    }
  })
}

function isApolloQuery(res?: ErrorRequestLike): res is AxiosResponse<FetchResult> {
  return !!res?.config?.isApolloQuery
}
